import {
    GETMAPPINGBANKNAMELIST_SUCCESS,
    GETMAPPINGBANKNAMELIST_FAILED,
    RESET_GETMAPPINGBANKNAMELIST,
    LOADING_GETMAPPINGBANKNAMELIST,
    NETWORK_ERROR_GETMAPPINGBANKNAMELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMAPPINGBANKNAMELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMAPPINGBANKNAMELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMAPPINGBANKNAMELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMAPPINGBANKNAMELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMAPPINGBANKNAMELIST:
            return (state = initialState);
        default:
            return state;
    }
};
